import { useState } from "react";
import { format } from "date-fns";
import { it } from "date-fns/locale";
import { CalendarIcon } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { Button } from "@/components/ui/button";
import { isoDate } from "@/lib/format";

export const DatePicker = ({ value, onChange, testId, placeholder = "Seleziona data", clearable = false, compact = false, disabled = false, className = "", maxDate }) => {
  const [open, setOpen] = useState(false);
  const date = value ? new Date(`${value}T00:00:00`) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" disabled={disabled} data-testid={testId} className={`w-full justify-start bg-white font-normal ${className}`}>
          <CalendarIcon className="mr-2 h-4 w-4 shrink-0" />
          {date ? format(date, compact ? "dd/MM/yyyy" : "EEEE d MMMM yyyy", { locale: it }) : <span className="text-muted-foreground">{placeholder}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" locale={it} selected={date} defaultMonth={date} captionLayout="dropdown-buttons" fromYear={1950} toYear={maxDate ? maxDate.getFullYear() : new Date().getFullYear() + 10}
          disabled={maxDate ? { after: maxDate } : undefined} toDate={maxDate}
          classNames={{ caption_label: "hidden", caption_dropdowns: "flex gap-1", dropdown: "h-7 border bg-white px-1 text-sm capitalize", vhidden: "sr-only" }}
          onSelect={(d) => { if (d) onChange(isoDate(d)); setOpen(false); }} initialFocus />
        {clearable && value && <div className="border-t p-2"><Button size="sm" variant="ghost" className="w-full" onClick={() => { onChange(""); setOpen(false); }} data-testid={testId && `${testId}-clear`}>Rimuovi data</Button></div>}
      </PopoverContent>
    </Popover>
  );
};
